define('app/views/simple_timer_view',['app/setup', 'flip-clock'], function (takhfifan, flipClock) {
  takhfifan.SimpleTimerView = Backbone.View.extend({
    initialize: function (attrs) {
      var remaining = parseInt(this.$el.data('second-remainig'), 10);
      this.days = parseInt(remaining / 86400);
      this.seconds = remaining;

      this.render();
    },
    render: function () {
      var clockWrapper = this.$el.find('.deal-countdown'),
          clickOptions = {
          autoStart: true,
          countdown: true,
          language: 'persian',
          clockFace: 'MinuteCounter'
        };


      this.$el.find('.deal-timer-loading').fadeOut(function () {
        $(this).remove();
      });

      if (this.seconds === 0) {
        clickOptions.autoStart = false;
      }

      if (this.days < 1) {
        clickOptions.clockFace = 'HourlyCounter';
      } else {
        clickOptions.clockFace = 'DailyCounter';
        clickOptions.showSeconds = false;
      }
      this.clock = new FlipClock(clockWrapper, this.seconds, clickOptions);
    }
  });

});




